module.exports = __webpack_public_path__ + "static/media/jroAsstBG.89d0dac6.png";